import api from '../api';

export async function getAllows() {
  return api.get('nutrient_group/allows');
}
  
export async function getNutrientGroups(description, numOfRegisters = 10, page = 1, order) {
  const params = {
    order: order ? order : 'description',
  }
  if (description) {
    params.description = description.trim(); 
  }

  return api.get('nutrient_group', {
    params,
    headers: {
      registerperpage: numOfRegisters,
      page
    }
  });
}

export async function getNutrientGroup(id) {
  return api.get(`nutrient_group/${id}`);
}

export async function postGroupTemplate(groupTemplate) {
  return api.post(`nutrient_group/`, groupTemplate);
}

export async function putGroupTemplate(id, data) {
  return api.put(`nutrient_group/${id}`, data);
}

export async function deleteGroupTemplate(id) {
  return api.delete(`nutrient_group/${id}`);
}

export async function findNutrientGroup(description, numOfRegisters = 6) {
  return api.get('nutrient_group', {
    params: {
      description,
      order: 'description'
    },
    headers: {
      registerperpage: numOfRegisters,
      page: 1
    }
  });
}